import React from 'react'

export const IconArrowRight = ({ width, height }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width ? width : "32"} height={height ? height : "32"} viewBox="0 0 32 32" fill="none">
            <path fill="currentColor" d="M4 16a1 1 0 0 0 1 1h19.586l-7.294 7.292a1 1 0 0 0 1.415 1.415l9-9a1 1 0 0 0 0-1.414l-9-9a1 1 0 1 0-1.415 1.415L24.586 15H5a1 1 0 0 0-1 1z"/>
        </svg>
    )
}